import type { ToolSetEntryDraft } from './updateToolSetAndEntries';

type SourceOrderKey = {
  kind: ToolSetEntryDraft['kind'];
  key: string;
};

/**
 * Inserts a configured source and sorts Configured sources to match Available sources order.
 * @param entries Current configured entries.
 * @param newEntry Entry to insert.
 * @param availableSources Catalog order of all sources (native groups then MCP).
 * @returns New entries array with `newEntry` included, ordered like Available sources.
 */
export function insertEntryInAvailableSourceOrder(
  entries: readonly ToolSetEntryDraft[],
  newEntry: ToolSetEntryDraft,
  availableSources: ReadonlyArray<SourceOrderKey>,
): ToolSetEntryDraft[] {
  const orderIndex = new Map(
    availableSources.map((source, index) => [`${source.kind}:${source.key}`, index] as const),
  );

  function catalogOrder(entry: SourceOrderKey): number {
    return orderIndex.get(`${entry.kind}:${entry.key}`) ?? Number.MAX_SAFE_INTEGER;
  }

  return [...entries, newEntry].sort((left, right) => {
    const orderDiff = catalogOrder(left) - catalogOrder(right);
    if (orderDiff !== 0) {
      return orderDiff;
    }
    if (left.kind !== right.kind) {
      return left.kind.localeCompare(right.kind);
    }
    return left.key.localeCompare(right.key);
  });
}
